import { Loading } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { getSeInvitationURL } from "../../../services/auth/auth.service";
import { links } from "../../../constants/links";
import { useEffect, useState } from "react";

const GetURL = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const urlKey = location.pathname.split("/")[2];
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getSeInvitationURL({ id: urlKey }).then((data) => {
      if (data?.url) {
        window.location.href = data.url;
      } else {
        navigate(`${links.MAIN}`);
      }
    }).catch(() => {
      navigate(`${links.MAIN}`);
    console.log("catch");
    }).finally(() => {
      setIsLoading(false);
    });
  }, [urlKey]);

  return (
    <div>
      {
        isLoading && <Loading />
      }
    </div>
  );
};

export default GetURL;
